/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';

/**
 * 
 * @export
 * @interface PendingEnrollmentRow
 */
export interface PendingEnrollmentRow {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof PendingEnrollmentRow
     */
    id: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {string}
     * @memberof PendingEnrollmentRow
     */
    studentName: string;
    /**
     * 
     * @type {string}
     * @memberof PendingEnrollmentRow
     */
    className: string;
    /**
     * 
     * @type {Date}
     * @memberof PendingEnrollmentRow
     */
    createdAt: Date;
}

/**
 * Check if a given object implements the PendingEnrollmentRow interface.
 */
export function instanceOfPendingEnrollmentRow(value: object): value is PendingEnrollmentRow {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('studentName' in value) || value['studentName'] === undefined) return false;
    if (!('className' in value) || value['className'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function PendingEnrollmentRowFromJSON(json: any): PendingEnrollmentRow {
    return PendingEnrollmentRowFromJSONTyped(json, false);
}

export function PendingEnrollmentRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): PendingEnrollmentRow {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['id']),
        'studentName': json['studentName'],
        'className': json['className'],
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function PendingEnrollmentRowToJSON(json: any): PendingEnrollmentRow {
    return PendingEnrollmentRowToJSONTyped(json, false);
}

export function PendingEnrollmentRowToJSONTyped(value?: PendingEnrollmentRow | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetLastSelectedIdParameterToJSON(value['id']),
        'studentName': value['studentName'],
        'className': value['className'],
        'createdAt': value['createdAt'].toISOString(),
    };
}

